import Swal from "sweetalert2";

import faradayApi from "../../api/faradayApi";
import { checkingCredentials, login, logout } from "./authSlice";

export const startSignIn = (
  email,
  password,
  language,
  isRememberChecked,
  pushToken
) => {
  return async (dispatch) => {
    dispatch(checkingCredentials());
    try {
      const { data } = await faradayApi.post("/user/login", {
        email,
        password,
        pushToken,
      });
      if (isRememberChecked) {
        localStorage.setItem("token", data.token);
      } else {
        sessionStorage.setItem("token", data.token);
      }

      dispatch(login({ user: data }));
    } catch (error) {
      try {
        window.flutter_inappwebview.callHandler("notifications");
        dispatch(logout());
      } catch (error) {
        dispatch(logout());
      }
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: error.response.data?.[`msg_${language}`],
        icon: "error",
        iconColor: "#FF7765",
      });
    }
  };
};

export const startSignInWithToken = () => {
  return async (dispatch) => {
    dispatch(checkingCredentials());

    try {
      const { data } = await faradayApi.get("/user/login");
      dispatch(login({ user: data }));
    } catch (error) {
      try {
        window.flutter_inappwebview.callHandler("notifications");
        dispatch(logout());
      } catch (error) {
        dispatch(logout());
      }
      console.log({ error });
    }
  };
};

export const startUpdateUser = (formValues, handleCancel, setIsDisabled, t) => {
  return async (dispatch) => {
    try {
      const { data } = await faradayApi.put("/user/updateById", formValues);

      data.status
        ? Swal.fire({
            confirmButtonColor: "#001B60",
            text: t("popupMsg.successEditProfile"),
            icon: "success",
          })
        : Swal.fire({
            confirmButtonColor: "#001B60",
            text: t("popupMsg.errorEditProfile"),
            icon: "error",
            iconColor: "#FF7765",
          });
      setIsDisabled(true);
    } catch (error) {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: t("popupMsg.errorEditProfile"),
        icon: "error",
        iconColor: "#FF7765",
      });
      handleCancel();
    }
  };
};
